import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    sameAddress: Boolean,
    useSavedBillingAddress: String, // use String because "-1" is a string in HTML forms
  };

  static targets = ['sameAddressCheckbox', 'addressData', 'savedSelector', 'newRadio', 'newFields'];

  connect() {
    // Sync initial checkbox state from value (or from DOM if you prefer)
    if (this.hasSameAddressCheckboxTarget) {
      this.sameAddressCheckboxTarget.checked = !!this.sameAddressValue;
    }

    this.render();
  }

  sameAddressChanged(event) {
    this.sameAddressValue = event.target.checked;
    this.render();
  }

  savedBillingChanged(event) {
    // event target might be the select OR the radio
    const val = event.target.value;
    this.useSavedBillingAddressValue = val;
    console.log("hitit!")
    this.renderNewFields();
  }

  render() {
    // address fields visible when NOT same address
    const showAddressFields = !this.sameAddressValue;
    if (this.hasAddressDataTarget) this.toggle(this.addressDataTarget, showAddressFields);

    // If the whole section is hidden, also hide new fields to avoid weird transitions
    if (!showAddressFields && this.hasNewFieldsTarget) this.toggle(this.newFieldsTarget, false);

    // Otherwise, update new fields visibility based on selection
    if (showAddressFields) this.renderNewFields();
  }

  renderNewFields() {
    if (!this.hasNewFieldsTarget) return;

    // Determine current selection:
    // - Prefer the changed value stored in Stimulus value
    // - Fallback to select/radio DOM state if needed
    let selected = this.useSavedBillingAddressValue;

    if (!selected) {
      if (this.hasSavedSelectorTarget) selected = this.savedSelectorTarget.value;
      if (!selected && this.hasNewRadioTarget && this.newRadioTarget.checked) selected = '-1';
    }

    const showNew = selected === '-1';
    console.log({ showNew });
    this.toggle(this.newFieldsTarget, showNew);
  }

  toggle(element, show) {
    if (!element) return;

    if (show) {
      element.classList.remove('opacity-0', 'scale-95', 'max-h-0', 'overflow-hidden');
      element.classList.add('opacity-100', 'scale-100', 'max-h-[1000px]');
    } else {
      element.classList.add('opacity-0', 'scale-95', 'max-h-0', 'overflow-hidden');
      element.classList.remove('opacity-100', 'scale-100', 'max-h-[1000px]');
    }

    element.setAttribute('aria-hidden', (!show).toString());
    element.querySelectorAll('input, select, textarea, button').forEach((el) => {
      el.disabled = !show;
    });
  }
}
